import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=42779a72"
import script from "./DepartmentSelect.vue?vue&type=script&lang=js"
export * from "./DepartmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports